import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityRemoveUser } from '../../projectDetailsActivities.models';

export const RemoveUserActivity = ({ values }: IProjectActivity<IProjectActivityRemoveUser>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_RemoveUser_01')}
      <b>{values.email}</b>
      {t('activity_description_RemoveUser_02')}.
    </span>
  );
};
